import { render, staticRenderFns } from "./AutoRefresh.vue?vue&type=template&id=3993d316&scoped=true&"
import script from "./AutoRefresh.vue?vue&type=script&lang=js&"
export * from "./AutoRefresh.vue?vue&type=script&lang=js&"
import style0 from "./AutoRefresh.vue?vue&type=style&index=0&id=3993d316&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993d316",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox});
